import { Component, OnDestroy } from '@angular/core';

import { BreadcrumbItem } from '@scalefast/core';
import { BreadcrumbService, ProductBreadcrumbService } from '@scalefast/ecommerce-core';
import { Observable, Subscription, map } from 'rxjs';

import { AsyncPipe } from '@angular/common';
import { UrlService } from '../../services/url.service';
import { AppBreadcrumbTemplateComponent } from './breadcrumbs-template/breadcrumb-template.component';

@Component({
  selector: 'app-breadcrumb',
  template: '<app-breadcrumb-template [breadcrumbItems]="breadcrumbs$ | async"  [isPdp]="isPdp"/>',
  standalone: true,
  imports: [AppBreadcrumbTemplateComponent, AsyncPipe],
})
export class AppBreadcrumbComponent implements OnDestroy {
  breadcrumbs$: Observable<BreadcrumbItem[]> = new Observable<BreadcrumbItem[]>();
  urlServiceSubscription: Subscription | undefined;
  productTitle: string | undefined;
  isPdp = false;

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly productBreadcrumbService: ProductBreadcrumbService,
    private readonly urlService: UrlService,
  ) {
    this.urlServiceSubscription = this.isAPdp().subscribe((isPdp) => {
      this.isPdp = isPdp;
      if (isPdp) {
        this.breadcrumbs$ = this.productBreadcrumbService.breadcrumbs$;
      } else {
        this.breadcrumbs$ = this.breadcrumbService.breadcrumbs$;
      }
    });
  }

  public isAPdp(): Observable<boolean> {
    return this.urlService.currentUrl$.pipe(map((url) => url.includes('/product/')));
  }

  ngOnDestroy(): void {
    this.urlServiceSubscription?.unsubscribe();
  }
}
